import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constant';

function UpdateFeesModal({
  createInputNumber,
  updateFees,
  formData,
  // history,
  getItem,
  setFormData,
  creating,
  feeData,
  permitId,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      amount: _.get(feeData, 'attributes.amount') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(feeData)) {
      OnSetFormData();
    }
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    updateFees(permitId, _.get(feeData, 'id'), formData, () => {
      setModal({ isOpen: false });
      // getAppointmentsList();
      // history.push(`/usermanagement/${_.get(data, 'id')}`);

      getItem(permitId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'amount', label: 'Amount:' },
              { required: true, placeholder: 'Amount' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateFeesModal.propTypes = {
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  updateFees: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  feeData: PropTypes.instanceOf(Object).isRequired,
  // history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  permitId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.UPDATE_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateFeesModal);
